import React, { useContext } from 'react';
import {
  UploadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileOutlined,
} from '@ant-design/icons';
import { Upload, Modal, Tooltip } from 'antd';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import ModalInfoCreateText from '../HbxAutoInvoice/ModalInfoCreateText/ModalInfoCreateText.jsx';
import HbxUploadTemplatesHook from './HbxUploadTemplates.hook.js';
import { AppContext } from 'App.context.js';
import styles from './HbxUploadTemplates.styles.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import RequestSuscription from '../../../common/RequestSuscription/RequestSuscription.jsx';
import InfoView from 'Components/common/InfoView/InfoView';
import { InfoCircleOutlined, EyeOutlined } from '@ant-design/icons';
import AdviceDeleteFile from '../AdviceDeleteFile/AdviceDeleteFile.jsx';
import Loading from 'Components/common/Loader/Loading';

export default function HbxUploadTemplates() {
  const { state, actions } = HbxUploadTemplatesHook();
  const languages = ['es', 'en', 'de', 'ca', 'fr', 'pt', 'it', 'ja', 'zh', 'pt_BR', 'ru', 'nl'];
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  // dividir en filas de 4 idiomas (3 filas)
  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };
  const rows = chunk(languages, 4);

  return (
    <DefaultLayout singleBox>
      {state.suscription ? (
        <div>
          {state.isLoading || !appState?.hotelList?.length ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {state.isLoading ? (
                <Loading />
              ) : (
                <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
              )}
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <div style={styles.fileTreatment}>
                <div style={{ ...styles.highlightTitle, ...styles.structureTitle }}>
                  <span>{translate('hbxProducts.invoiceAutomationFiles.title')}</span>
                  <AppButton
                    text={'Ver Guía'}
                    action={() => actions.openInfoModal()}
                    style={styles.buttonGuide}
                    icon={<EyeOutlined style={{ color: '#1890ff', fontSize: '16px' }} />}
                  />
                </div>

                <div style={styles.grid}>
                  {rows.map((row, rowIndex) => (
                    <div key={rowIndex} style={styles.row}>
                      {row.map(lang => {
                        const exists = Boolean(state.listTemplates?.[lang]);
                        return (
                          <div key={lang} style={styles.langCard}>
                            <div style={styles.langTitle}>
                              <img
                                style={styles.langTitleIcon}
                                src={require(`../../../../assets/images/icons/language/${lang}.png`)}
                              />
                              <span style={{ marginLeft: 8 }}>
                                {translate(`hbxProducts.invoiceAutomationFiles.language.${lang}`)}
                              </span>
                              <span style={styles.statusIcon}>
                                {exists ? (
                                  <CheckCircleOutlined style={{ color: 'green', marginLeft: 8 }} />
                                ) : (
                                  <CloseCircleOutlined style={{ color: 'red', marginLeft: 8 }} />
                                )}
                              </span>
                            </div>

                            <div style={styles.langActions}>
                              {exists ? (
                                <div style={styles.smallActions}>
                                  <div style={styles.fileName}>
                                    <FileOutlined style={styles.fileIcon} />
                                    {`${lang}_invoice_template`}
                                  </div>
                                  <div style={styles.leftActions}>
                                    <Tooltip
                                      title={
                                        translate(
                                          'hbxProducts.invoiceAutomationFiles.downloadFile'
                                        ) +
                                        ' ' +
                                        translate(
                                          `hbxProducts.invoiceAutomationFiles.language.${lang}`
                                        )
                                      }
                                    >
                                      <div
                                        style={styles.smallActionItem}
                                        onClick={() => actions.downloadFile(lang)}
                                      >
                                        <DownloadOutlined style={styles.smallIcon} />
                                      </div>
                                    </Tooltip>

                                    <Tooltip
                                      title={
                                        translate('hbxProducts.invoiceAutomationFiles.deleteFile') +
                                        ' ' +
                                        translate(
                                          `hbxProducts.invoiceAutomationFiles.language.${lang}`
                                        )
                                      }
                                    >
                                      <div
                                        style={{ ...styles.smallActionItem, color: 'red' }}
                                        onClick={() => {
                                          actions.setLanguageDelete(lang);
                                          actions.setAdviceDeleteFile(true);
                                        }}
                                      >
                                        <DeleteOutlined
                                          style={{ ...styles.smallIcon, color: 'red' }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              ) : (
                                <Upload
                                  accept=".docx"
                                  maxCount={1}
                                  beforeUpload={file => {
                                    actions.UploadDocument(file, lang);
                                    return false;
                                  }}
                                  showUploadList={false}
                                >
                                  <div style={styles.uploadBox}>
                                    <UploadOutlined style={styles.uploadIcon} />
                                    <div style={styles.uploadText}>
                                      {translate('hbxProducts.invoiceAutomationFiles.uploadFile') +
                                        translate(
                                          `hbxProducts.invoiceAutomationFiles.language.${lang}`
                                        )}
                                    </div>
                                  </div>
                                </Upload>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>

                <Modal
                  title={translate('hbxProducts.adviceDeleteFile')}
                  open={state.adviceDeleteFile}
                  onCancel={() => actions.setAdviceDeleteFile(false)}
                  cancelText={translate('hbxProducts.cancel')}
                  onOk={() => {
                    actions.setAdviceDeleteFile(false);
                    actions.deleteFile();
                  }}
                  okText={translate('hbxProducts.delete')}
                  okType={'danger'}
                >
                  <AdviceDeleteFile setShowModal={actions.setAdviceDeleteFile} />
                </Modal>

                <Modal
                  type="info"
                  open={state.isModalOpen}
                  onCancel={() => actions.closeInfoModal()}
                  width={1600}
                  bodyStyle={{ fontSize: '16px', lineHeight: '1.6' }}
                  footer={null}
                >
                  <ModalInfoCreateText />
                </Modal>
              </div>
            </div>
          )}
        </div>
      ) : (
        <RequestSuscription suscription="hbx_invoicing" />
      )}
    </DefaultLayout>
  );
}
